export default __webpack_public_path__ + "static/media/suport3.b5dea89a.jpg";